import { usePromotePageState } from 'src/app/pages/promote/pageContext';

export function useShouldHideForExperiment(): boolean {
	const [{ usingSavedPaymentMethod, savedPaymentExperimentVariant }] = usePromotePageState();

	return savedPaymentExperimentVariant === 'variant_2' && usingSavedPaymentMethod;
}
